<template>
  <div>
    <div v-if="ageGroup" id="questions" class="panel active">
      <StageQuestion
        :key="questionIndex"
        :symptom="ageGroup.symptoms[symptomIndex]"
        :question="questions[questionIndex]"
        :page="stage['page_name']"
        @action="handleAction"
      />
    </div>

    <div class="questionnaire-buttons container text-centered">
      <div class="tool-button previous mx-xs-2" @click="onPrevious" v-html="$getString('GLOBAL_BUTTON_BACK')"></div>
      <div :class="[ 'tool-button next mx-xs-2', { disabled: !next } ]" @click="onNext" v-html="$getString('GLOBAL_BUTTON_NEXT')"></div>
    </div>
  </div>
</template>

<script>
import StageQuestion from './StageQuestion.vue'

export default {
  name: 'StageQuestions',
  components: {
    StageQuestion,
  },
  props: {
    stage: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      age: -1,
      ageGroup: null,
      symptoms: [],
      questions: [],
      questionIndex: -1,
      symptomIndex: -1,
      next: false,

      handlers: {
        'select-answer': this.onSelectAnswer,
      },
    }
  },
  methods: {
    handleAction(event) {
      if (event.type in this.handlers) {
        this.handlers[event.type](event.data);
      } else {
        this.$emit('action', event);
      }
    },
    validateAnswerArray(index) {
      let answers = this.questions[this.questionIndex].answers;
      if (index === -1) {
        if (answers.length > 0 && answers.indexOf(-1) === -1) {
          answers = [];
        }
      } else if (answers.indexOf(-1) > -1) {
        answers = [];
      }
      return answers;
    },
    onSelectAnswer(data) {
      const questions = this.questions;
      this.questions[this.questionIndex].answers = this.validateAnswerArray(data);

      const answerIndex = questions[this.questionIndex].answers.indexOf(data);
      if (answerIndex > -1) {
        questions[this.questionIndex].answers.splice(answerIndex, 1);
      } else {
        questions[this.questionIndex].answers.push(data);
      }

      this.questions = questions;
      this.$store.commit('SetData', { key: 'questions', value: this.questions });

      this.checkNextButton();
    },

    onPrevious() {
      this.$emit('action', { type: 'decrement-page' });

      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_Back`,
      } });

      if (this.questionIndex > 0) {
        this.previousQuestion();
      } else {
        this.$emit('action', { type: 'goto-stage', data: 'symptoms' });
      }
    },
    onNext() {
      if (!this.next) return;
      this.next = false;

      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_Continue`,
      } });

      const added = this.$store.getters.dataKey('addedSymptoms');
      this.$emit('action', { type: 'increment-page' });

      if (this.questionIndex + 1 < this.questions.length) {
        this.nextQuestion();
      } else if (added || this.symptoms.length === this.ageGroup.symptoms.length) {
        this.$emit('action', { type: 'goto-stage', data: 'sliders' });
      } else {
        this.$emit('action', { type: 'goto-stage', data: 'add-symptoms' });
      }
    },
    openSymptomPopup(index) {
      const symptom = this.ageGroup.symptoms[index];
      this.$emit('action', { type: 'open-popup', data: {
        type: 'symptom',
        heading: symptom.label,
        items: symptom.popupList,
      }});
    },

    updateQuestion() {
      const question = this.questions[this.questionIndex];
      this.symptomIndex = question.symptom;
      
      this.$store.commit('SetData', { key: 'question', value: this.questionIndex });
      this.$store.commit('setQuestionLabel', question.analytics.label);
      console.log(question.analytics.label, this.$store.getters.questionLabel);
    },
    previousQuestion() {
      this.questionIndex -= 1;
      this.updateQuestion();
      this.checkNextButton();
    },
    nextQuestion() {
      this.questionIndex += 1;
      this.updateQuestion();
      this.checkNextButton();
    },
    
    checkNextButton() {
      this.next = this.questions[this.questionIndex].answers.length > 0;
    },
  },
  mounted() {
    this.age = this.$store.getters.dataKey('age');
    this.symptoms = this.$store.getters.dataKey('symptoms');
    this.questions = this.$store.getters.dataKey('questions');
    this.questionIndex = this.$store.getters.dataKey('question');
    if (this.questionIndex < 0 || this.questionIndex >= this.questions.length) {
      this.questionIndex = 0;
      this.$store.commit('SetData', { key: 'question', value: this.questionIndex });
    }
    this.updateQuestion();
    this.checkNextButton();
    
    this.ageGroup = this.$store.getters.ageGroup;
  },
}
</script>
